import { Route, Routes } from "react-router-dom";
import FacultyReport from "./UnivDataComponents/FacultyReport";
import UniversitySubjectFacReport from "./UnivDataComponents/UniversitySubjectFacReport";
import UnivwiseReport from "./UnivDataComponents/UnivwiseReport";
import UniversityWiseSubAndFacultyRepo from "./UnivDataComponents/UniversityWiseSubAndFacultyRepo";
import AddUniversityDtls from "./UnivDataComponents/AddUniversityDtls";
import LoginPage from "./UnivDataComponents/LoginPage";
import MainDashboard from "./UnivDataComponents/MainDashboard";
import SubjectWiseFacultyData from "./UnivDataComponents/SubjectWiseFacultyData";
import RusaDashboard from "./UnivDataComponents/Dashboard";
import AddDepartment from "./UnivDataComponents/AddDepartment";
import UniversityFacultyData from "./UnivDataComponents/UniversityFacultyData";
import FacultydetailsEdit from "./UnivDataComponents/FacultydetailsEdit";
import SubjectwiseReport from "./UnivDataComponents/SubjectwiseReport";
import MenuBar from "./UnivDataComponents/MenuBar";
import ChangePassword from "./ChangePassword";
import ForgotPassword from "./ForgotPassword";
import SubjectConsolidatedReport from "./UnivDataComponents/SubjectConsolidatedReport";
import DeptWiseStatusReport from "./UnivDataComponents/DeptWiseStatusReport";

import NonTeachingFaculty from "./UnivDataComponents/NonTeachingFaculty";
import NonTeachingFacultyData from "./UnivDataComponents/NonTeachingFacultyData";
import NonTeachingFacultyDetailsRepo from "./UnivDataComponents/NonTeachingFacultyDetailsRepo";
import CollegeEmployeeMapping from "./UnivDataComponents/CollegeEmployeeMapping";
import CollegeEmployeeMappingNon from "./UnivDataComponents/CollegeEmployeeMappingNon";
import FacultyDashboardReport from "./UnivDataComponents/FacultyDashboardReport";

import DesignationMaster from "./UnivDataComponents/DesignationMaster";


const RoutesComponent = () => (
    <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<MenuBar><MainDashboard /></MenuBar>} />
        <Route path="/Universiyedit" element={<MenuBar><UniversityFacultyData /></MenuBar>} />
        <Route path="/SubjectWiseFacultyData" element={<MenuBar><SubjectWiseFacultyData /></MenuBar>} />
        <Route path="/AddDepartment" element={<MenuBar><AddDepartment /></MenuBar>} />
        <Route path="/FacultyReport" element={<MenuBar><FacultyReport /></MenuBar>} />
        <Route path="/UniversitySubjectFacReport" element={<MenuBar><UniversitySubjectFacReport /></MenuBar>} />
        <Route path="/UnivwiseReport" element={<MenuBar><UnivwiseReport /></MenuBar>} />
        <Route path="/UniversityWiseSubAndFacultyRepo" element={<MenuBar><UniversityWiseSubAndFacultyRepo /></MenuBar>} />
        <Route path="/AddUniversityDtls" element={<MenuBar><AddUniversityDtls /></MenuBar>} />
        <Route path="/SubjectwiseReport" element={<MenuBar><SubjectwiseReport /></MenuBar>} />
        <Route path="/DeptWiseStatusReport" element={<MenuBar><DeptWiseStatusReport /></MenuBar>} />



        <Route path="/SubjectConsolidatedReport" element={<MenuBar><SubjectConsolidatedReport /></MenuBar>} />

        <Route path="/RusaDashboard" element={<RusaDashboard />} />
        <Route path="/UniversityFacultyData" element={<MenuBar><FacultydetailsEdit /></MenuBar>} />
        <Route path="/ChangePassword" element={<MenuBar><ChangePassword /></MenuBar>} />
        <Route path="/NonTeachingFaculty" element={<MenuBar><NonTeachingFaculty /></MenuBar>} />
        <Route path="/NonTeachingFacultyEdit" element={<MenuBar><NonTeachingFacultyData /></MenuBar>} />
        <Route path="/NonTeachingFacultyDetailsRepo" element={<MenuBar><NonTeachingFacultyDetailsRepo /></MenuBar>} />
        <Route path="/CollegeEmployeeMapping" element={<MenuBar><CollegeEmployeeMapping /></MenuBar>} />
        <Route path="/CollegeEmployeeMappingNon" element={<MenuBar><CollegeEmployeeMappingNon /></MenuBar>} />
        <Route path="/FacultyDashboardReport" element={<MenuBar><FacultyDashboardReport /></MenuBar>} />
        <Route path="/DesignationMaster" element={<MenuBar><DesignationMaster /></MenuBar>} />



        <Route path="/ForgotPassword" element={<ForgotPassword />} />

        {/* <Route path="/NonTeachingFacultyDetailsRepo" element={<MenuBar><NonTeachingFacultyDetailsRepo /></MenuBar>} />

                <Route path="/NonTeachingFaculty" element={<MenuBar><NonTeachingFaculty /></MenuBar>} />
                        <Route path="/DesignationMaster" element={<MenuBar><DesignationMaster /></MenuBar>} /> */}


    </Routes>
);

export default RoutesComponent;